<template>
  <fragment>
    <b-form>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Email:" :invalid-feedback="invalidFeedback">
            <b-form-input
                v-model="$v.email.$model"
                :state="validateState('email')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-button
              variant="primary"
              @click="onCreateHandler"
              :disabled="loading"
          >
            <b-spinner v-if="loading" small/>
            <span v-else>Create</span>
          </b-button>
          <b-button
              variant="white"
              class="ml-3"
              :disabled="loading"
              @click="$emit('cancel')"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="mt-3">
      <b-col cols="12">
        <b-alert :show="!!registrationToken" variant="success">
          New member created with email: {{ email }}!
          <br/>
          Registration link:
          <br>
          {{ registrationLink }}
        </b-alert>
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {email, required} from 'vuelidate/lib/validators';
import validateStateMixin from '@/mixins/validateStateMixin';
import {handleServerErrorWithValidation} from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';

export default {
  name: 'CreateDemoMember',
  mixins: [validationMixin, validateStateMixin],
  props: {
    societyId: [Number, String],
  },
  data: function () {
    return {
      email: null,
      alreadyExists: false,
      loading: false,
      registrationToken: null,
    };
  },
  validations: {
    email: {
      email,
      required,
    },
  },
  computed: {
    invalidFeedback: function () {
      return !this.$v.email.email
          ? 'Please enter a valid Email address.'
          : 'This field is required';
    },
    registrationLink: function () {
      if (!this.registrationToken) return '';
      return `${window.location.origin}/#/sign-up/${this.registrationToken}`;
    },
  },
  methods: {
    onCreateHandler: async function () {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.loading = true;
      this.registrationToken = null;
      try {
        const { member, registration_token } = await Api.createDemoMember(
            this.societyId,
            this.email
        );
        this.registrationToken = registration_token;
        this.$emit('created', member);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
